import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { EMPTY } from "rxjs";
import { tap } from "rxjs/operators";
import { TagsActions } from "./tags.actions";
import { TagsStateModel } from "./tags.state.model";
import { TagsApiService } from "src/app/services/api/tags-api.service";

@State<TagsStateModel>({
    name: 'tags',
    defaults: {
        tags: []
    },
})
@Injectable()
export class TagsState{
    constructor(private tagsApiService: TagsApiService) {}

    @Action(TagsActions.SetAllTags)
    SetAllTags(ctx: StateContext<TagsStateModel>) {
        const state = ctx.getState();
        if (state.tags && state.tags.length > 0) return EMPTY;

        return this.tagsApiService.get().pipe(
            tap((tags) => {
                if (tags)
                  ctx.patchState({tags: tags})
            })
        );
    }

    @Action(TagsActions.RefreshAllTags)
    RefreshAllTags(ctx: StateContext<TagsStateModel>) {
        return this.tagsApiService.get().pipe(
            tap((tags) => {
                if (tags)
                  ctx.patchState({tags: tags})
            })
        );
    }

    @Selector()
    static getAllTags(state: TagsStateModel){
      return [...state.tags]
        .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
    }
}
